/** Заготовки лидеров сети на фронте. Ключи map — value города, не подписи. */

const MOSCOW_LEADERS = ["Иванов Алексей", "Петров Борис"];

const ROSTOV_LEADERS = ["Сидоров Виктор", "Козлов Григорий"];

const PRESETS_BY_CITY_ID: Record<string, string[]> = {
  "1": MOSCOW_LEADERS,
  "2": ROSTOV_LEADERS,
};

function normalizeCityLabel(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/-на-дону$/, "")
    .replace(/\s+/g, " ");
}

const PRESETS_BY_CITY_LABEL: Record<string, string[]> = {
  москва: MOSCOW_LEADERS,
  ростов: ROSTOV_LEADERS,
};

export function networkLeaderPresetsForCity(
  cityId: string,
  cityLabel = "",
): string[] {
  const byId = PRESETS_BY_CITY_ID[String(cityId)];
  if (byId?.length) return byId;

  const normalized = normalizeCityLabel(cityLabel);
  if (!normalized) return [];
  if (PRESETS_BY_CITY_LABEL[normalized])
    return PRESETS_BY_CITY_LABEL[normalized];
  if (normalized.includes("москва")) return MOSCOW_LEADERS;
  if (normalized.includes("ростов")) return ROSTOV_LEADERS;
  return [];
}
